const techRoute = [
  {
    path: '/coreTechnology',
    component: () => import('@/views/core-technology'),
    redirect: '/coreTechnology/index',
    meta: {
      title: '核心技术',
      breadcrumb: true,
      layout: 'DefaultLayout',
    },
    children: [
      {
        path: "index",
        component: () => import('@/views/core-technology/main.vue'),
        hidden: true,
        meta: {
          title: "核心技术",
          breadcrumb: false,
        }
      }
    ]
  },
]
export default techRoute
